import { useTranslation } from 'react-i18next';
import { Stack, Typography } from "@mui/material"
import Utils from '../utils/Utils';
import Box from "@mui/material/Box";
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import DOMPurify from "dompurify";

interface ParticipantProps {
    id: number;
    image_index?: number;
    name: string;
    description?: string;
    onEditClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onDeleteClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Participant: React.FC<ParticipantProps> = ({
    image_index,
    name,
    description,
    onEditClick,
    onDeleteClick,
}) => {
    const { t } = useTranslation();

    const sanitizedDescription = description ? DOMPurify.sanitize(description) : "";

    return (
        <>
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" >
                <Typography
                    component="span"
                >
                    {name}
                </Typography>
                <Box>
                    <IconButton onClick={onEditClick} >
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={onDeleteClick}>
                        <PersonRemoveIcon />
                    </IconButton>
                </Box>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" width="100%">
                <img src={`/assets/${Utils.getParticipantImageFileName(image_index)}`} alt={t('actions.participants')}
                    style={{ maxWidth: '250px', maxHeight: '150px', padding: '10px' }} />
            </Stack>
            <Stack direction="row" width="100%">
                <Typography
                    component="span"
                    align='left'
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                />
            </Stack>
        </>
    );
}

export default Participant;